// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"483":"8bdeebfa","923":"f7f251ad"}[chunkId] + ".chunk.css";
};